/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class ReportingSharedService {
  private apiBaseUrl = `/api`;
  private generatedSnapshotReportBaseUrl = `${this.apiBaseUrl}/generatedSnapshotReport`;

  constructor(private readonly httpClient: HttpClient) {}

  downloadGeneratedSnapshotReport(uuid: any, params = []): void {
    const headers = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
    this.httpClient
      .post(`${this.generatedSnapshotReportBaseUrl}/download/${uuid}`, params, {
        headers,
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe((res) => {
        const contentDisposition = res.headers.get('content-disposition');
        const fileName = contentDisposition?.replace('attachment; filename=', '');

        const link = document.createElement('a');
        link.href = window.URL?.createObjectURL(res.body);
        link.download = fileName;
        link.click();
      });
  }
}
